export default {
  GET_ALL: `#graphql
  query getCodes($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getCodes(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        code,
        active,
        percent,
        value,
        type,
        brand,
        quantity,
        remaining,
        phone
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getCodesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getCodesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        code,
        active,
        percent,
        value,
        type,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewCode($code: CodeInput!) {
    newCode(input: $code)
    {
      code,
      active,
      percent,
      value,
      type,
      brand,
      quantity,
      remaining,
      phone
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateCode($code: String!, $codeUpdate: CodeUpdateInput!) {
    updateCode(code:$code, codeUpdate: $codeUpdate)
    {
      code
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteCode($code: String!) {
    deleteCode(code:$code)
    {
      code
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/code.js